export function formatLogIdDisplay(logId: string): string {
  const parts = logId.split('|');
  const lastPart = parts[parts.length - 1]?.trim();

  return lastPart || logId;
}
